import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useDowntimeShowModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.editDowntimeModalState, ...args };
    updateGlobalState({ editDowntimeModalState: newState });
  };

  return {
    block: state.editDowntimeModalState.block,
    close: () => {
      setState({ block: null, isOpen: false });
    },
    isOpen: state.editDowntimeModalState.isOpen,
    open: (block) => {
      setState({ block, isOpen: true });
    },
  };
}
